import React from 'react';
import { Settings } from '@one-thd/sui-icons';
import { Pill } from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';

const LinksSettings = () => {

  const { ref, clickID } = useImpression({
    data: {
      component: 'LinksContent',
      name: 'LinksContent',
      id: 'settings',
      position: 1, // Assuming this is the first item
      type: 'content',
    }
  });

  return (
    <>
      <div className="first:sui-snap-start last:sui-snap-end" data-component="LinksSettings">
        <Pill
          ref={ref}
          clickid={clickID}
          label={
            (
              <div className="sui-flex sui-items-center">
                <Settings size="small" />
              </div>
            )
          }
        />
      </div>
      {/* Add your component content here */}
    </>
  );
};

export default LinksSettings;